import _             from 'underscore';
import React, { FC } from 'react';
import classNames    from 'classnames';

import { ClosableHeader, ClosableHeaderProps } from './ClosableHeader';
import { CorvalColor, OneOrArrayOf }           from '../../types';
import { Cell, Grid }                          from 'styled-css-grid';
import { ClassValue }                          from 'classnames/types';

export interface SidebarContainerProps extends Pick<ClosableHeaderProps, 'onClose' | 'title'> {
	padded?: boolean,
	cellRows?: OneOrArrayOf<String>,
	cellRowClassNames?: OneOrArrayOf<ClassValue>,
	dark?: boolean,
	light?: boolean,
	themeColor?: CorvalColor,
}

let defaultProps: SidebarContainerProps = {
	title:             null,
	onClose:           null,
	padded:            true,
	cellRows:          null,
	cellRowClassNames: null,
	dark:              false,
	light:             false,
	themeColor:        null,
};

const SidebarContainer: FC<SidebarContainerProps> = ( props ) => {
	
	let hasThemeColor    = ( props.themeColor !== null ),
	    containerClasses = classNames( {
		    'container--fill-area':                            true,
		    'padding-md':                                      ( props.padded === true ),
		    'container--colored-bg-charcoal':                  ( !hasThemeColor && props.dark ),
		    'container--colored-bg-lunar':                     ( !hasThemeColor && props.light ),
		    [ `container--colored-bg-${ props.themeColor }` ]: hasThemeColor,
	    } );
	
	let hasTitle             = ( props.title || props.onClose ),
	    hasCellDefs          = _.isArray( props.cellRows ) || _.isString( props.cellRows ),
	    hasCellClassNameDefs = _.isArray( props.cellRowClassNames ),
	    hasMultipleCellDefs  = _.isArray( props.cellRows ) && props.cellRows.length > 0,
	    cellRowDimensions    = hasCellDefs ? hasMultipleCellDefs ? ( props.cellRows as string[] ).join( ' ' ) : props.cellRows : '1fr';
	
	return (
		<Grid className={ containerClasses }
		      flow={ 'column' }
		      columns={ 1 }
		      columnGap={ '0px' }
		      rowGap={ '0px' }
		      rows={ `${ hasTitle ? 'auto' : '' } ${ cellRowDimensions }` }>
			
			{ hasTitle && (
				<Cell>
					<ClosableHeader onClose={ props.onClose } title={ props.title }/>
				</Cell>
			) }
			
			{ hasCellDefs ? (
				
				<>
					{ _.isArray( props.children )
					  ? props.children.map( ( child, index ) => <Cell key={ index } className={ hasCellClassNameDefs ? classNames( props.cellRowClassNames[ index ] ?? null ) : null }>{ child }</Cell> )
					  : props.children }
				</>
			
			) : (
				  <Cell>
					
					  { props.children }
				
				  </Cell>
			  ) }
		
		</Grid>
	);
};

SidebarContainer.defaultProps = defaultProps;

export { SidebarContainer }
